/**
 * Estensioni che il prodotto considera "foto". La lista viveva copiata in tre
 * punti (tab Varianti, ponte File Storage, DmsUploader): tre copie della stessa
 * regola si disallineano al primo formato aggiunto.
 *
 * Modulo puro — nessun import dello store: e' consumato da componenti caricati
 * dal router (vedi .claude/rules/_always.md § "Utility caricate dal router").
 */

export const IMAGE_EXT = ['png', 'jpg', 'jpeg', 'gif', 'svg', 'webp', 'bmp']

/**
 * Input:  estensione grezza (`ext` dell'allegato, con o senza maiuscole)
 * Output: bool
 */
export function isImageExt(ext) {
	return IMAGE_EXT.indexOf(String(ext || '').toLowerCase()) !== -1
}
